import React from "react";
import { Field } from "react-final-form";
import CheckboxAdapter from "../../Adapters/CheckboxAdapter";

const CheckboxComponent = (props) => {
  let name = props;
  let initialValue = props;

  return (
    <Field
      name={name}
      component={CheckboxAdapter}
      type="checkbox"
      initialValue={initialValue}
      subscription={{ touched: true, value: true, error: true }}
      {...props}
    />
  );
};

export default CheckboxComponent;
